export default __webpack_public_path__ + "static/PlayfairDisplay-Bold-ad329ba5b6f909da68732d82d624b0c0.woff";